import { useEffect, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { ColorPreview } from "./common/ColorPreview";
import { ErrorBox } from "./common/ErrorBox";
import { useFormContext } from "react-hook-form";
import { InfoModal } from "../components/InfoModal";

export const ColorPicker = ({
  name,
  label,
  title,
  detailed_label,
  options,
  validation,
  errors,
  selectedColor,
  description
}) => {
  //const [selectedColor, setSelectedColor] = useState(null);
  console.log("re-render colorpicker");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { register, setValue, trigger } = useFormContext();
 
  /*
  useEffect(()=>{
    if(selectedColor){ // avoid first time render
      setValue(name, selectedColor,{ shouldValidate: true });  
    } 
  },[selectedColor])
*/
  const handleColorClick = (code) => {
    //setSelectedColor(code); // Update de geselecteerde kleur
    setValue(name, code,{ shouldValidate: true });  
  };

  return (
    <>
      <div className="bg-white/60 rounded-2xl shadow-sm border border-gray-200/60 p-3.5 transition-all duration-200 hover:bg-white/80 hover:shadow-md backdrop-blur-sm">
        <div className="flex justify-between items-start mb-2">
          <h2 className="text-base font-semibold text-gray-900">
            {title}
          </h2>
          <AiOutlineInfoCircle
            className="text-gray-600 text-base cursor-pointer hover:text-gray-800 transition-colors flex-shrink-0"
            onClick={() => setIsModalOpen(true)}
          />
        </div>

        <p className="text-sm text-gray-600 mb-3">{detailed_label}</p>

        <div className="flex flex-wrap gap-x-4 gap-y-3 mt-1">
          {options.map((color, i) => (
            <div key={i} className="flex flex-col items-center" style={{ width: '56px' }}>
              <ColorPreview
                color={color.color}
                diameter={56}
                code={color.code}
                label={color.label}
                handleColorClick={handleColorClick}
                key={i}
                selected={selectedColor == color.code}
              />
              <label
                className="text-[9px] mt-1.5 text-center text-gray-600 dark:text-gray-400 font-medium leading-tight w-full break-words"
                title={color.label}
              >
                {color.label}
              </label>
            </div>
          ))}
        </div>

        <input type="hidden" {...register(name, {
    required: "Color is required",
  })} />

        <ErrorBox errors={errors} />
      </div>

      <InfoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={title}
      >
        <p className="text-sm leading-relaxed">{description}</p>
      </InfoModal>
    </>
  );
};
